import SkeletonCard from '@components/Skeleton';
import TransactionHeaderMobile from '@assets/images/background/transaction-header-mobile.svg';
import TransactionHeaderTablet from '@assets/images/background/transaction-header-tablet.svg';
import TransactionHeaderDesktop from '@assets/images/background/transaction-header-desktop.svg';

export default function Skeleton() {
	return (
		<div className='flex flex-col w-full pb-6 my-6 desktop:bg-[#00000008] rounded-t-lg relative'>
			<>
				<div className='tablet:hidden absolute top-0 w-full object-cover rounded-t-lg'>
					<TransactionHeaderMobile />
				</div>
				<div className='hidden tablet:block desktop:hidden absolute top-0 w-full object-cover rounded-t-lg'>
					<TransactionHeaderTablet />
				</div>
				<div className='hidden desktop:block absolute top-0 w-full object-cover rounded-t-lg'>
					<TransactionHeaderDesktop />
				</div>
			</>
			<div className='flex w-full justify-between bg-black rounded-t-lg pt-4 pb-[18px] desktop:pb-[25px] px-6'>
				<div className='z-10'>
					<div className='w-[120px] h-6 bg-blue-grey-darkest rounded mb-2'></div>
					<div className='w-[120px] h-4 bg-blue-grey-darkest rounded'></div>
				</div>
				<div className='z-10 flex flex-col items-end'>
					<div className='w-[60px] h-6 bg-blue-grey-darkest rounded mb-2'></div>
					<div className='w-10 h-4 bg-blue-grey-darkest rounded'></div>
				</div>
			</div>
			<div className='flex flex-col w-full px-6 desktop:bg-[#00000008] rounded-t-lg'>
				<SkeletonCard className={'relative rounded-lg'} />
			</div>
		</div>
	);
}
